// Duits (de-DE), kioskWeather: zelfde vorm als kioskWeather.nl.ts. Zelfde woorden als in
// weatherPrayer.de.ts (weather.feel, weather.itemLabels, weather.stale). Wat ontbreekt valt terug
// op het Nederlands.
export const kioskWeatherDe = {
    title: 'Wetter',
    open: 'Wetter: {feel}. Tippen für mehr.',
    stale: 'Wetter gerade unbekannt',
    today: 'Heute',
    tomorrow: 'Morgen',
    close: 'Schließen',
    feel: { cold: 'kalt', chilly: 'frisch', mild: 'angenehm', warm: 'warm', hot: 'heiß' },
    itemLabels: {
        thick_coat: 'Dicke Jacke',
        coat: 'Jacke',
        sweater: 'Pulli',
        raincoat: 'Regenjacke',
        boots: 'Gummistiefel',
        hat_gloves: 'Mütze und Handschuhe',
        umbrella: 'Regenschirm',
        sunscreen: 'Eincremen',
        sun_hat: 'Kappe auf',
        water_bottle: 'Trinkflasche',
        shorts: 'Kurze Hose',
    },
    day: {
        today: 'So wird es heute',
        tomorrow: 'So wird es morgen',
        temp: 'Wie warm?',
        tempValue: '{min} bis {max} Grad',
        feels: 'Es fühlt sich {feel} an',
        rain: 'Regen',
        rainWords: {
            dry: 'Es bleibt trocken',
            small: 'Vielleicht ein kleiner Schauer',
            likely: 'Es kann regnen',
            wet: 'Es wird regnen',
        },
        rainWhen: 'Von {from} bis {until}',
        wind: 'Wind',
        windWords: {
            calm: 'Kaum Wind',
            light: 'Ein bisschen Wind',
            fresh: 'Ganz schön windig',
            strong: 'Starker Wind',
            very_strong: 'Sehr starker Wind',
        },
        windForce: 'Windstärke {bft}',
        sun: 'Sonne',
        sunrise: 'Auf um {time}',
        sunset: 'Unter um {time}',
        uvWords: {
            moderate: 'Die Sonne ist stark. Lange draußen? Dann eincremen.',
            high: 'Die Sonne ist sehr stark. Eincremen und Mütze auf.',
        },
        course: 'Wie wird der Tag?',
        back: 'Zurück',
        now: 'Jetzt',
    },
};
//# sourceMappingURL=kioskWeather.de.js.map